// npm

// css
import '../../scss/pages/page-job.scss';

// libs
import AnchorScroll from '../_libs/AnchorScroll';
import RecruitFV from '../_libs/RecruitFV';

// utils
import RecruitFoundation from '../_utils/RecruitFoundation';
RecruitFoundation();

document.addEventListener('DOMContentLoaded', () => {
	AnchorScroll('.js-anchor-scroll', null, 1200);
});

window.addEventListener('load', () => {
	RecruitFV();
});
